import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Точечно правит query-параметры, не трогая остальные: null/undefined удаляют
 * параметр, всё прочее пишется строкой.
 */
export const useUpdateQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const updateSearchQuery = useCallback(
    (
      queryParams: Record<string, string | number | boolean | null | undefined>
    ) => {
      const next = new URLSearchParams(searchParams);

      Object.entries(queryParams).forEach(([key, value]) => {
        if (value === undefined || value === null) {
          next.delete(key);
        } else {
          next.set(key, String(value));
        }
      });

      setSearchParams(next);
    },
    [searchParams, setSearchParams]
  );

  return [searchParams, updateSearchQuery] as const;
};
